__turbopack_context__.v({
  "adminSearch": "styles-module-scss-module__mTmOeq__adminSearch",
  "adminSelect": "styles-module-scss-module__mTmOeq__adminSelect",
});
